import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';
import { ResetPasswordHeader } from '@/components/auth/password/ResetPasswordHeader';
import { ResetPasswordForm } from '@/components/auth/password/ResetPasswordForm';
import { ResetPasswordFooter } from '@/components/auth/password/ResetPasswordFooter';
import { ResetPasswordValues } from '@/components/auth/password/resetPasswordSchema';

const ResetPassword: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [formError, setFormError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleResetPassword = async (values: ResetPasswordValues) => {
    setFormError(null);
    setIsLoading(true);
    try {
      console.log('Updating password');
      const { error } = await supabase.auth.updateUser({
        password: values.password
      });

      if (error) {
        console.error('Password update error:', error);
        throw error;
      }
    
      console.log('Password updated successfully');
      toast({
        title: "Password updated successfully",
        description: "Your password has been changed. You can now log in with your new password.",
      });

      // Sign out and redirect to login
      await supabase.auth.signOut();
      navigate('/login');
    } catch (error) {
      console.error("Error updating password:", error);
      const errorMessage = error instanceof Error ? error.message : "Failed to update password. Please try again.";
      setFormError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-background p-4">
      <div className="w-full max-w-md space-y-8">
        <ResetPasswordHeader />
        <ResetPasswordForm 
          onSubmit={handleResetPassword}
          isLoading={isLoading}
          error={formError}
        />
        <ResetPasswordFooter />
      </div>
    </div>
  );
};

export default ResetPassword;
